import './GridCarouselStyle.less';

import { ImgixImg } from '@opendoor/bricks';
import React from 'react';

interface IProps {
  colSize: 1 | 2 | 3 | 4 | 6 | 12;
  onLeftClick: () => void;
  onRightClick: () => void;
  selectedIndex: number;
  speed?: number;
}

const defaultProps: Partial<IProps> = {
  speed: 200,
};

const GridCarousel: React.SFC<IProps> = props => {
  const { children, colSize, onRightClick, onLeftClick, selectedIndex, speed } = props;

  const horizontalMultiplier = +((100 / 12) * colSize).toFixed(6);
  const horizontalOffset = horizontalMultiplier * -selectedIndex;
  const transform = `translateX(${horizontalOffset}%)`;
  const transition = `transform ${speed}ms`;

  return (
    <div className="od-grid-carousel">
      <div className="od-grid-carousel__container">
        <div className="row bottom-xs od-grid-carousel__track" style={{ transform, transition }}>
          {children}
        </div>
      </div>
      <div className="od-grid-carousel__arrow od-grid-carousel__arrow-left" onClick={onLeftClick}>
        <ImgixImg className="od-grid-carousel__img" src="back.svg" />
      </div>
      <div className="od-grid-carousel__arrow od-grid-carousel__arrow-right" onClick={onRightClick}>
        <ImgixImg className="od-grid-carousel__img" src="next.svg" />
      </div>
    </div>
  );
};

GridCarousel.defaultProps = defaultProps;

export default GridCarousel;
